interface LabTestDisplayData {
  name: string;
  markers: ReadonlyArray<{ name: string }>;
  metadata: { auto_generated?: boolean | null };
}

export function getLabOrderDisplayName(labTest: LabTestDisplayData): string {
  if (!labTest.metadata.auto_generated) return labTest.name || 'Lab order';

  const markerNames = [...new Set(labTest.markers.map(({ name }) => name.trim()).filter(Boolean))];
  return markerNames.join(', ') || 'Lab order';
}
